export default "__VITE_ASSET__Bflxj4G1__"